<form class="form">
    <div class="form-data">
        <app-form-generator
            [formGeneratorInput]="reportNameFormGenInput"
            (formGroupRef)="reportNameFormGroup = $event"
        ></app-form-generator>
        <app-widget-selector
            [viewId]="false"
            [apiUrl]="ApiUrls.MANAGED_REPORTS_SIDEBAR"
            [supportedFormats]="[SupportedFormat.REPORT]"
            [selectedMap]="widgetsSelectedMap"
            [selectedIds]="widgetsSelected"
            [limit]="GlobalConfiguration.REPORT_LIMIT"
            (widgetsSelectedIds)="
                widgetsSelected = $event; noWidgetsSelected = false
            "
            (widgetsSelectedMap)="widgetsSelectedMap = $event"
        ></app-widget-selector>
        <div class="no-widgets" *ngIf="noWidgetsSelected">
            <i class="fas fa-exclamation-triangle color-warn"></i>
            Select atleast one widget
        </div>
    </div>
    <div class="form-controls">
        <app-button-generator
            *ngIf="nextButton"
            [buttonGenInput]="nextButton"
        ></app-button-generator>
    </div>
</form>
